import useRouteSyncSearchType from 'hooks/useRouteSyncSearchType'
import React, { useEffect } from 'react'
import { of, switchMap, startWith } from 'rxjs'
import { debounceTime, map } from 'rxjs/operators'
import { useDispatch } from 'react-redux'
import { result } from 'libraries/lodash'
import { getPageUrl } from 'libraries/front-end-core/core/history'
import { updateBreakpoints } from 'services/AccordionService'
import LayoutContainer from 'redux/containers/components/LayoutContainer'
import useBaseState from 'hooks/useBaseState'
import {
  setLayoutWrapperState,
  layoutWrapperSetUrl,
  setCmsCtx
} from 'redux/actions'
import { setLayoutController } from 'redux/actions/layout'

const LayoutWrapperComponent = (props) => {
  const {
    state,
    query,
    flavour,
    searchType
  } = props
  const pageUrl = getPageUrl(location.href)

  const { baseState } = useBaseState(
    state.pipe(
      debounceTime(5),
      map(s => Object.assign(s, {
        pageId: result(s, 'layoutData.pageId', pageUrl),
        query: result(s, 'layoutData.query', query),
        searchType: result(
          s,
          'layoutData.searchType',
          searchType
        ),
        url: result(s, 'layoutData.url', pageUrl),
        flavour: result(s, 'layoutData.flavour', flavour)
      })
      ),
      switchMap(
        s =>
          baseState.pageId !== s.pageId
            ? of(s)
              .pipe(startWith({ pageId: null }))
            : of(s)
      )
    )
    ,
    {
      pageId: pageUrl,
      layoutData: {},
      pageData: {}
    },
    [state, query, searchType, flavour]
  )
  const dispatch = useDispatch()
  useRouteSyncSearchType(baseState.searchType)

  useEffect(() => {
    dispatch(setCmsCtx())
  }, [])

  // Sync controller with route
  useEffect(() => {
    dispatch(setLayoutController())
  }, [location.href])

  useEffect(() => {
    dispatch(layoutWrapperSetUrl(pageUrl))
  }, [pageUrl])

  useEffect(() => {
    updateBreakpoints()
  }, [])
  // this base state effect stuff seems to be causing minor havoc with redux state updates, might be worth refactoring in future?
  // for now removing url from here and relying only on the above "layoutWrapperSetUrl" which seems more consistent.
  useEffect(() => {
    const { query, layoutData, pageData } = baseState
    if (layoutData) {
      const { bottleLink } = layoutData
      dispatch(setLayoutWrapperState({ query, bottleLink, pageData }))
    }
  }, [baseState])

  const toComponent = (Component, data, key) => Component ? <Component key={key} {...data} /> : null

  const { pageId, layoutData = {}, pageData = {}, components: { Main, Left, Right, Header } = {} } = baseState

  if (pageId === null) {
    return <LayoutContainer {...layoutData} />
  }

  const main = toComponent(Main, pageData, 'main')
  const left = toComponent(Left, pageData, 'left')
  const right = toComponent(Right, pageData, 'right')
  const header = toComponent(Header, pageData, 'header')

  return (
    <LayoutContainer
      {...layoutData}
      feedbackOptions={layoutData.feedbackOptions}
      {...{ main, left, right, header, pageId }}
    />
  )
}

export default LayoutWrapperComponent
